import { useLingui } from "@lingui/react/macro";
import Heading from "../Heading";
import ApiKey from "./partials/ApiKey";
import Documentation from "./partials/Documentation";
import AllEarsTitle from "@components/AllEarsTitle";

export default function SettingsApiView() {
  const { t } = useLingui();

  const title = t`API-tillgång`;

  return (
    <>
      <AllEarsTitle title={title} />

      <Heading
        heading={title}
        description={t`Använd den här nyckeln för att autentisera mot All Ears API.`}
      />

      <div className="w-full p-4 lg:p-6 max-w-7xl flex flex-col gap-8">
        <ApiKey />
        <Documentation />
      </div>
    </>
  );
}
